import React from 'react'
import { useHistory } from 'react-router'
import CurrentUser from '../../components/authentication/CurrentUser'
import { signOut } from 'daily-dose-common'
import { Button, Grid, Typography } from '@material-ui/core'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'
import HttpsSharpIcon from '@material-ui/icons/HttpsSharp'
import HelpIcon from '@material-ui/icons/Help'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import buildInfo from '../../../package.json'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    divider: {
      margin: theme.spacing(1, 0),
    },
  })
)

const UserProfilePage = () => {
  const history = useHistory()

  //TODO to be implemented once whe have content for Privicy and Terms & conditions modal
  /* const onOpenPrivicyPage = () => {
    openDialog({
      color: 'primary',
      title: 'Privacy Policies',
      confirmText: '',
      custom: true,
      description: <Privacy onClosePrivacyPage={() => closeDialog()} />,
      fullScreen: true,
    })
  }

  const onOpenTermsAndConditions = () => {
    openDialog({
      color: 'primary',
      title: 'Terms and Conditions',
      confirmText: '',
      custom: true,
      description: (
        <TermsAndConditions onCloseTermsAndConditions={() => closeDialog()} />
      ),
      fullScreen: true,
    })
  } */

  const onGoToAccountSettings = () => {
    history.push('account-settings')
  }

  const onGoToHelpAndSupport = () => {
    history.push('help-and-support')
  }

  const classes = useStyles()

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CurrentUser />
      </Grid>
      <Grid item xs={12}>
        <List component="nav">
          <ListItem button onClick={onGoToAccountSettings}>
            <ListItemIcon>
              <HttpsSharpIcon />
            </ListItemIcon>
            <ListItemText primary="Account Settings" />
          </ListItem>
          <Divider className={classes.divider} />
          <ListItem button onClick={onGoToHelpAndSupport}>
            <ListItemIcon>
              <HelpIcon />
            </ListItemIcon>
            <ListItemText primary="Help and Support" />
          </ListItem>
        </List>
      </Grid>
      <Grid container item xs={12} justify="center">
        <Button color="primary" variant="contained" onClick={signOut}>
          Sign Out
        </Button>
      </Grid>
      <Grid container item xs={12} justify="center">
        <Typography variant="caption" color="textSecondary">
          Version: {buildInfo.version}
        </Typography>
      </Grid>
    </Grid>
  )
}

export default UserProfilePage
